// extracted by mini-css-extract-plugin
module.exports = {"container":"addItem_container__3YUoV","add":"addItem_add__1b6kO","icon":"addItem_icon__31YVm"};